import {StatusPageComponentsBulkDeleteAction} from "./StatusPageComponentsBulkDeleteAction.tsx";

interface TableBulkActionsBarProps {
  selectedItems: Record<string, boolean>;
  setSelectedItems: (selectedItems: Record<string, boolean>) => void;
  statusPageId: number;
}

export const TableBulkActionsBar = ({selectedItems, setSelectedItems, statusPageId}: TableBulkActionsBarProps) => {
  return (
    <StatusPageComponentsBulkDeleteAction
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      statusPageId={statusPageId}
    />
  );
};
